import useSWR from "swr";
import { useTranslation } from "react-i18next";
import { fetcher } from "@/lib/api";

export default function PegadaVehiculo({ period }) {
  const { t } = useTranslation();
  const { data } = useSWR(`/carbon/summary?period=${period}`, fetcher);
  const rows = data?.breakdown_por_vehiculo || [];
  const emptyFleet = data?.empty_fleet;

  return (
    <div data-testid="pegada-vehiculo">
      <div className="rounded-2xl border hairline bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-salnes-sand/40 text-salnes-stone">
            <tr>
              <Th>{t("fase3.vehicle_plate")}</Th>
              <Th>{t("fase3.vehicle_fuel")}</Th>
              <Th className="text-right">{t("fase3.vehicle_km")}</Th>
              <Th className="text-right">{t("fase3.vehicle_litres")}</Th>
              <Th className="text-right">{t("fase3.vehicle_kgco2e")}</Th>
            </tr>
          </thead>
          <tbody className="divide-y hairline">
            {rows.map((r) => (
              <tr
                key={r.plate}
                data-testid={`vehicle-row-${r.plate}`}
                className="hover:bg-salnes-sand/20 transition-colors"
              >
                <Td className="font-mono text-salnes-ink">{r.plate}</Td>
                <Td>{r.fuel}</Td>
                <Td className="text-right tabular-nums">{r.km?.toLocaleString("es-ES")}</Td>
                <Td className="text-right tabular-nums">{r.litros_estimados?.toLocaleString("es-ES")}</Td>
                <Td className="text-right tabular-nums font-medium">{r.kgco2e?.toLocaleString("es-ES")}</Td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr data-testid="pegada-vehiculo-empty">
                <td colSpan="5" className="text-center py-10 text-salnes-stone text-sm px-6">
                  {emptyFleet ? t("fase3.no_fleet") : "—"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Th = ({ children, className = "" }) => (
  <th className={`text-left text-[10px] uppercase tracking-[0.18em] font-medium px-4 py-3 ${className}`}>
    {children}
  </th>
);
const Td = ({ children, className = "" }) => (
  <td className={`px-4 py-3 ${className}`}>{children}</td>
);
